import moment from 'moment'
import { isValidRomRecord } from './tracpatch.error.filter'

// Strict ROM-Test picker for the admin TracPatch Extension / Flexion charts.
// A clinically meaningful daily reading needs three things:
//   - is_rom_test === true (active ROM Test, not a passive sensor event)
//   - the record passes the centralized error filter (see
//     tracpatch.error.filter.js for the rules)
//   - if multiple qualify on the same day, latest endTime wins
// Days with NO qualifying record render as a gap (no point plotted) — the
// chart's line generator naturally skips null readings.
//
// Diverges intentionally from physio_server/src/business/patient.js's
// `is_rom_test:-1 / endTime:-1` fall-through. The patient-list summary
// has a single-value cell to keep populated for the column to stay
// useful, so it falls back to the latest passive record when no ROM
// Test exists. A chart has more room to honestly show "no test this
// day" without losing utility, so we choose the stricter behavior here.

export function pickRomTestPerDay(records, options) {
  const opts = options || {}
  const cutoff = opts.windowStart || null  // moment | null — drop records before this

  const byDay = {}
  if (!Array.isArray(records)) return byDay

  records.forEach((r) => {
    if (!r || !r.is_rom_test) return
    if (!isValidRomRecord(r)) return
    if (cutoff && moment(r.startTime).isBefore(cutoff)) return
    const day = moment(r.startTime).format('YYYY-MM-DD')
    const existing = byDay[day]
    if (!existing || moment(r.endTime).isAfter(moment(existing.endTime))) {
      byDay[day] = r
    }
  })
  return byDay
}
